export default __webpack_public_path__ + "static/media/PUBLI_1_ORG_12.9060f20e.png";